import { jsx as _jsx } from "react/jsx-runtime";
import { HolderOutlined } from "@ant-design/icons";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { SortableContext, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button } from "antd";
import { createContext, useContext, useMemo, useRef } from "react";
import { DndContext } from "@dnd-kit/core";
let RowContext;
let RowsContext;
const DragHandle = ()=>{
    const { setActivatorNodeRef, listeners } = useContext(RowContext);
    return /*#__PURE__*/ _jsx(Button, {
        type: "text",
        size: "small",
        icon: /*#__PURE__*/ _jsx(HolderOutlined, {}),
        style: {
            cursor: "move"
        },
        ref: setActivatorNodeRef,
        ...listeners
    });
};
const Row = (props)=>{
    const { elementType = "tr" } = useContext(RowsContext);
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
        id: props["data-row-key"]
    });
    const style = {
        ...props.style,
        transform: CSS.Translate.toString(transform),
        transition,
        ...isDragging ? {
            position: "relative",
            zIndex: 9999
        } : {}
    };
    const contextValue = useMemo(()=>({
            setActivatorNodeRef,
            listeners
        }), [
        setActivatorNodeRef,
        listeners
    ]);
    const renderedProps = {
        ...props,
        ref: setNodeRef,
        style,
        ...attributes
    };
    return /*#__PURE__*/ _jsx(RowContext.Provider, {
        value: contextValue,
        children: elementType === "li" ? /*#__PURE__*/ _jsx("li", {
            ...renderedProps
        }) : elementType === "div" ? /*#__PURE__*/ _jsx("div", {
            ...renderedProps
        }) : /*#__PURE__*/ _jsx("tr", {
            ...renderedProps
        })
    });
};
function useDndSortable() {
    if (!RowContext) {
        RowContext = /*#__PURE__*/ createContext({});
        RowsContext = /*#__PURE__*/ createContext({});
    }
    // We can safely use `useRef` as we are using contexts, to keep `useEffect` from re-rendering the component intact
    return useRef({
        SortableContext: function(param) {
            let { children, onDragEnd, items, ...rowsContextProps } = param;
            return /*#__PURE__*/ _jsx(RowsContext.Provider, {
                value: rowsContextProps,
                children: /*#__PURE__*/ _jsx(DndContext, {
                    modifiers: [
                        restrictToVerticalAxis
                    ],
                    onDragEnd: onDragEnd,
                    // Avoid validateDOMNesting warning when using the SortableContext inside a table.
                    // See also https://github.com/clauderic/dnd-kit/issues/899#issuecomment-1264700799
                    accessibility: {
                        container: document.body
                    },
                    children: /*#__PURE__*/ _jsx(SortableContext, {
                        items: items,
                        strategy: verticalListSortingStrategy,
                        children: children
                    })
                })
            });
        },
        SortableRow: Row,
        DragHandle
    }).current;
}
export { useDndSortable };
